<template>
  <div class="dealer-buttons">
    <a
      v-show="showSpecialOffers && shopSiteLink"
      :href="`${shopSiteLink}specialoffers`"
      class="btn btn-primary"
      @click="clickSpecialOffers"
    >{{ "dealers.details.specialOffers" | t }}</a>

    <a
      v-if="showShopSiteLink"
      :href="`${shopSiteLink}`"
      class="btn btn-secondary"
      @click="clickShopSiteLink"
    >{{ "dealers.details.shopSite" | t }}</a>

    <a
      v-else-if="showCartLink"
      :href="`${shopSiteLink}checkout/`"
      class="btn btn-secondary"
      @click="clickViewCartLink"
    >{{ "dealers.details.viewCart" | t }}</a>

    <a
      :href="`/locator/?changeDealer=true&returnurl=${returnUrl}`"
      class="btn btn-secondary"
      @click="clickChangeMyDealer"
    >{{ "dealers.details.changeMyDealer" | t }}</a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DealerButtons",
  data() {
    return {
      returnUrl: window.location.href
    };
  },
  computed: {
    ...mapGetters("DealerHeader", ["dealer", "showSpecialOffers"]),
    shopSiteLink() {
      return this.dealer?.shopSiteLink != null
        ? this.dealer.shopSiteLink
        : false;
    },
    showShopSiteLink() {
      return this.shopSiteLink && !this.dealer.express
    },
    showCartLink() {
      return this.shopSiteLink && this.dealer.express
    }
  },
  methods: {
    clickSpecialOffers() {
      this.$dataLayer.push({ event: "pcedh.special-offers-clicked" });
    },
    clickShopSiteLink() {
      this.$dataLayer.push({ event: "pcedh.shop-site-clicked" });
    },
    clickViewCartLink() {
      this.$dataLayer.push({ event: "pcedh.view-cart-clicked" });
    },
    clickChangeMyDealer() {
      this.$dataLayer.push({ event: "pcedh.change-my-dealer-clicked" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dealer-buttons {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  flex: 1;
  order: 2;
  margin-bottom: $gutter;

  .btn {
    font-family: $font-title;
    width: 100%;
    line-height: 40px;
    box-sizing: border-box;
    text-align: center;
    color: $white;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
    margin-bottom: $gutter-sm;
  }
  .btn-primary {
    color: $white;
    background-color: $black;
  }
  .btn-secondary {
    color: $black;
    background-color: $white;
    border: $black 2px solid;
  }
  @media only screen and (max-width: $breakpoint-md) {
    .btn {
      margin-bottom: $gutter;
    }
    .dealer-buttons {
      order: 1;
      margin-bottom: $gutter-lg;
    }
  }

  [class^="icon-stihl-"]:before,
  [class*=" icon-stihl-"]:before {
    font-family: $font-icons;
  }
}
</style>
